import { SxStyles } from 'types/styles';

export const styles: SxStyles = {
  textArea: {
    height: 155,
  },
};
